export default __webpack_public_path__ + "6f67a93a1e43843831e5cea76cb8fd86.jpg";